export const TM_UPDATE_STATE = "TM_UPDATE_STATE"
export const TM_UPDATE_FORM_DATA = "TM_UPDATE_FORM_DATA"
export const TM_UPDATE_FORM_DATA_MESSAGE_DETAILS =
  "TM_UPDATE_FORM_DATA_MESSAGE_DETAILS"
export const TM_MORE_LOADED = "TM_MORE_LOADED"
export const TEMPLATE_CREATED = "TEMPLATE_CREATED"
export const TM_DELETED = "TM_DELETED"
